import { Add, Close } from '@mui/icons-material';
import { Button, Divider, FormControl, FormHelperText, Grid, InputLabel, MenuItem, OutlinedInput, Select, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useStateRef } from 'app/services';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect } from 'react';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
const TransportGroupCheckListForm = forwardRef((props, ref) => {
    const theme = useTheme();
    const { defaultValues, onSubmit } = props;
    const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(!!defaultValues);
    const { watch, control, setValue, register, handleSubmit, formState } = useForm(defaultValues
        ? { defaultValues: defaultValues }
        : {
            defaultValues: {
                name: '',
                active: 1,
                checkpoints: [
                    {
                        type: '',
                        title: '',
                        values: '',
                        required: 0,
                    },
                ],
            },
        });
    const { fields, append, remove, replace } = useFieldArray({
        name: 'checkpoints',
        control,
    });
    const watchFieldArray = watch('checkpoints');
    const handleChangeCheckpointsInput = (value, id) => {
        setValue(`checkpoints.${id}.values`, value.replace(/[!@#$%^&*()_+\-=[\]{}':"\\|,.<>/?]+/, ''));
    };
    const handlerChangeSelect = (value, id) => {
        if (value !== 'select') {
            setValue(`checkpoints.${id}.values`, '');
        }
        fields[id].type = value;
        setValue(`checkpoints.${id}.type`, value);
    };
    const handlerChangeRequired = (value, id) => {
        if (value !== 1) {
            setValue(`checkpoints.${id}.required`, 0);
        }
        fields[id].type = String(value);
        setValue(`checkpoints.${id}.required`, value);
    };
    const handleAppendCheckpoint = () => {
        append({
            type: '',
            title: '',
            values: '',
            required: 0,
        });
    };
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => onSubmit({
                id: defaultValues ? defaultValues.id : undefined,
                name: data.name,
                active: data.active,
                checkpoints: data.checkpoints,
            }))();
        },
    }));
    useLayoutEffect(() => {
        if (firstUpdateRef.current !== undefined) {
            setTimeout(() => setFirstUpdate(undefined), theme.transitions.duration.shorter);
        }
    }, [firstUpdateRef.current]);
    useEffect(() => {
        if (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.checkpoints) {
            replace(defaultValues.checkpoints.map(([type, title, values, required]) => ({
                type,
                title,
                values: String(values !== null && values !== void 0 ? values : ''),
                required: required ? 1 : 0,
            })));
        }
    }, [defaultValues]);
    return (React.createElement("form", null,
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FormControl, { error: !!formState.errors.name, variant: 'outlined', margin: 'normal', fullWidth: true },
                        React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                        React.createElement(OutlinedInput, Object.assign({ label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435', disabled: !!defaultValues, notched: firstUpdate, fullWidth: true, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435' }, register('name', {
                            required: true,
                            minLength: 3,
                        }))),
                        React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0447\u0435\u043A\u043B\u0438\u0441\u0442\u0430 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043F\u0438\u0441\u043A\u0430\u0445"))),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FormControl, { error: !!formState.errors.active, variant: 'outlined', margin: 'normal', fullWidth: true },
                        React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0421\u0442\u0430\u0442\u0443\u0441"),
                        React.createElement(Controller, { name: 'active', control: control, render: ({ field }) => (React.createElement(Select, Object.assign({ label: '\u0421\u0442\u0430\u0442\u0443\u0441', notched: firstUpdate, value: field.value, MenuProps: {
                                    sx: {
                                        '.MuiPaper-root:before': {
                                            display: 'none',
                                        },
                                    },
                                } }, register(field.name, {
                                required: true,
                            })),
                                React.createElement(MenuItem, { value: 0 }, "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D"),
                                React.createElement(MenuItem, { value: 1 }, "\u0410\u043A\u0442\u0438\u0432\u0435\u043D"))) }),
                        React.createElement(FormHelperText, null, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u0438 \u0447\u0435\u043A\u043B\u0438\u0441\u0442\u0430 \u043F\u0440\u0438 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043E\u0441\u043C\u043E\u0442\u0440\u0430")))),
            (fields.length !== 0 || !defaultValues) &&
                fields.map((field, i) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return (React.createElement(React.Fragment, { key: field.id },
                        React.createElement(Divider, { textAlign: 'center', sx: (theme) => ({
                                width: '100%',
                                alignSelf: 'center',
                                justifyContent: 'center',
                                marginTop: theme.spacing(1.25),
                                marginBottom: theme.spacing(1.25),
                            }) },
                            React.createElement(Typography, { variant: 'body2' },
                                "\u0427\u0435\u043A\u043F\u043E\u0438\u043D\u0442 ",
                                i + 1)),
                        React.createElement(Grid, { container: true, spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 6 },
                                React.createElement(FormControl, { error: !!((_b = (_a = formState.errors.checkpoints) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.title), margin: 'normal', fullWidth: true },
                                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A"),
                                    React.createElement(Controller, { name: `checkpoints.${i}.title`, defaultValue: '', control: control, rules: { required: true }, render: ({ field }) => (React.createElement(OutlinedInput, { label: '\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A', value: field.value, placeholder: '\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A', disabled: !!defaultValues, notched: firstUpdate, onChange: field.onChange, onBlur: field.onBlur, name: field.name, inputRef: field.ref })) }))),
                            React.createElement(Grid, { item: true, xs: !defaultValues && fields.length > 1 ? 4.5 : 6 },
                                React.createElement(FormControl, { error: !!((_d = (_c = formState.errors.checkpoints) === null || _c === void 0 ? void 0 : _c[i]) === null || _d === void 0 ? void 0 : _d.type), variant: 'outlined', margin: 'normal', fullWidth: true },
                                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0422\u0438\u043F"),
                                    React.createElement(Select, Object.assign({ label: '\u0422\u0438\u043F', notched: firstUpdate, disabled: !!defaultValues, value: watchFieldArray[i].type, MenuProps: {
                                            sx: {
                                                '.MuiPaper-root:before': {
                                                    display: 'none',
                                                },
                                            },
                                        } }, register(`checkpoints.${i}.type`, {
                                        required: true,
                                        onChange: (e) => handlerChangeSelect(e.target.value, i),
                                    })), config.transportGroupCheckListFormMenu.map((item, key) => (React.createElement(MenuItem, { key: key, value: item.value, disableRipple: true }, item.title)))))),
                            !defaultValues && fields.length > 1 && (React.createElement(Grid, { item: true, xs: 1.5 },
                                React.createElement(Button, { variant: 'contained', size: 'large', disableElevation: true, onClick: () => remove(i), endIcon: React.createElement(Close, null), sx: (theme) => ({
                                        position: 'relative',
                                        minWidth: 'auto',
                                        borderRadius: theme.spacing(1),
                                        color: theme.palette.text.secondary,
                                        padding: '12px 12px',
                                        bgcolor: 'background.default',
                                        marginTop: '15px',
                                        marginBottom: theme.spacing(1),
                                        marginLeft: '3px',
                                        span: {
                                            margin: theme.spacing(0),
                                        },
                                        path: {
                                            fill: theme.palette.text.secondary,
                                        },
                                        '&:hover, &.active': {
                                            bgcolor: 'background.default',
                                        },
                                    }) })))),
                        watchFieldArray && watchFieldArray[i] && watchFieldArray[i].type === 'select' && (React.createElement(Grid, { container: true, spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(FormControl, { error: !!((_f = (_e = formState.errors.checkpoints) === null || _e === void 0 ? void 0 : _e[i]) === null || _f === void 0 ? void 0 : _f.values), margin: 'normal', variant: 'outlined', fullWidth: true, sx: {
                                        width: '100%',
                                        marginTop: theme.spacing(2),
                                    } },
                                    React.createElement(InputLabel, null, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430"),
                                    React.createElement(OutlinedInput, Object.assign({ label: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430', placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430', disabled: !!defaultValues }, register(`checkpoints.${i}.values`, {
                                        onChange: (e) => handleChangeCheckpointsInput(e.target.value, i),
                                    }))),
                                    React.createElement(FormHelperText, null, "\u0415\u0441\u043B\u0438 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043F\u0443\u043D\u043A\u0442\u043E\u0432, \u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u0443\u043D\u043A\u0442 1;\u043F\u0443\u043D\u043A\u0442 2"))))),
                        watchFieldArray && watchFieldArray[i] && watchFieldArray[i].type === 'boolean' && (React.createElement(Grid, { container: true, spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(FormControl, { error: !!((_h = (_g = formState.errors.checkpoints) === null || _g === void 0 ? void 0 : _g[i]) === null || _h === void 0 ? void 0 : _h.required), margin: 'normal', variant: 'outlined', fullWidth: true, sx: {
                                        width: '100%',
                                        marginTop: theme.spacing(2),
                                    } },
                                    React.createElement(InputLabel, null, "\u0412\u043B\u0438\u044F\u0435\u0442 \u043D\u0430 \u0432\u044B\u0435\u0437\u0434"),
                                    React.createElement(Select, Object.assign({ label: '\u0412\u043B\u0438\u044F\u0435\u0442 \u043D\u0430 \u0432\u044B\u0435\u0437\u0434', notched: firstUpdate, disabled: !!defaultValues, value: watchFieldArray[i].required, MenuProps: {
                                            sx: {
                                                '.MuiPaper-root:before': {
                                                    display: 'none',
                                                },
                                            },
                                        } }, register(`checkpoints.${i}.required`, {
                                        onChange: (e) => handlerChangeRequired(Number(e.target.value), i),
                                    })),
                                        React.createElement(MenuItem, { value: 0, disableRipple: true }, "\u041D\u0435\u0442"),
                                        React.createElement(MenuItem, { value: 1, disableRipple: true }, "\u0414\u0430")),
                                    React.createElement(FormHelperText, null, "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442 \u0434\u043E\u043F\u0443\u0441\u043A \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u043A \u0432\u044B\u0435\u0437\u0434\u0443"))))),
                        fields.length - 1 === i && !defaultValues && (React.createElement(Divider, { textAlign: 'center', sx: (theme) => ({
                                width: '100%',
                                alignSelf: 'center',
                                justifyContent: 'center',
                                marginTop: theme.spacing(1.25),
                                marginBottom: theme.spacing(1.25),
                            }) },
                            React.createElement(Button, { variant: 'outlined', size: 'medium', onClick: () => handleAppendCheckpoint(), sx: (theme) => ({
                                    padding: '3px 10px',
                                    borderRadius: '50px',
                                    fontSize: '10px',
                                    minWidth: '40px',
                                    color: theme.palette.text.secondary,
                                    bgcolor: 'background.default',
                                    borderColor: 'background.default',
                                    '&:hover, &.active': {
                                        bgcolor: 'background.default',
                                        borderColor: 'background.default',
                                    },
                                    svg: {
                                        fontSize: '18px',
                                    },
                                }) },
                                React.createElement(Add, null))))));
                }))));
});
TransportGroupCheckListForm.displayName = 'TransportGroupCheckListForm';
export default TransportGroupCheckListForm;
